/** Donut simple en SVG (sin librerías) para el "Resumen del equipo" (mockup image3). */
export function DonutChart({
  data, centerValue, centerLabel,
}: {
  data: Array<{ label: string; value: number; color: string }>;
  centerValue: number | string;
  centerLabel?: string;
}) {
  const total = data.reduce((s, d) => s + d.value, 0) || 1;
  const R = 52, C = 2 * Math.PI * R, stroke = 18;
  let offset = 0;
  const segments = data.filter(d => d.value > 0).map((d, i) => {
    const frac = d.value / total;
    const dash = `${frac * C} ${C - frac * C}`;
    const seg = { key: i, color: d.color, dash, dashoffset: -offset * C };
    offset += frac;
    return seg;
  });

  return (
    <div className="flex flex-col items-center gap-3">
      <svg viewBox="0 0 140 140" className="w-40 h-40 -rotate-90">
        <circle cx="70" cy="70" r={R} fill="none" stroke="currentColor" className="text-muted/40" strokeWidth={stroke} />
        {segments.map(s => (
          <circle key={s.key} cx="70" cy="70" r={R} fill="none" stroke={s.color} strokeWidth={stroke}
            strokeDasharray={s.dash} strokeDashoffset={s.dashoffset} strokeLinecap="butt" />
        ))}
        <g className="rotate-90" style={{ transformOrigin: '70px 70px' }}>
          <text x="70" y="66" textAnchor="middle" className="fill-foreground" fontSize="24" fontWeight="700">{centerValue}</text>
          {centerLabel && <text x="70" y="84" textAnchor="middle" className="fill-muted-foreground" fontSize="10">{centerLabel}</text>}
        </g>
      </svg>
      <div className="flex flex-wrap gap-x-3 gap-y-1 justify-center">
        {data.filter(d => d.value > 0).map((d, i) => (
          <span key={i} className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
            <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: d.color }} />{d.label}
          </span>
        ))}
      </div>
    </div>
  );
}
